/*
 * Action Types
 */
export enum NotificationsTypes {
  LIST_NOTIFICATIONS_REQUEST = '@notifications/LIST_NOTIFICATIONS_REQUEST',
  LIST_NOTIFICATIONS_SUCCESS = '@notifications/LIST_NOTIFICATIONS_SUCCESS',
  LIST_NOTIFICATIONS_FAILURE = '@notifications/LIST_NOTIFICATIONS_FAILURE',

  GET_NOTIFICATION_REQUEST = '@notifications/GET_NOTIFICATION_REQUEST',
  GET_NOTIFICATION_SUCCESS = '@notifications/GET_NOTIFICATION_SUCCESS',
  GET_NOTIFICATION_FAILURE = '@notifications/GET_NOTIFICATION_FAILURE',

  CREATE_NOTIFICATION_REQUEST = '@notifications/CREATE_NOTIFICATION_REQUEST',
  CREATE_NOTIFICATION_SUCCESS = '@notifications/CREATE_NOTIFICATION_SUCCESS',
  CREATE_NOTIFICATION_FAILURE = '@notifications/CREATE_NOTIFICATION_FAILURE',

  UPDATE_NOTIFICATION_REQUEST = '@notifications/UPDATE_NOTIFICATION_REQUEST',
  UPDATE_NOTIFICATION_SUCCESS = '@notifications/UPDATE_NOTIFICATION_SUCCESS',
  UPDATE_NOTIFICATION_FAILURE = '@notifications/UPDATE_NOTIFICATION_FAILURE',

  DELETE_NOTIFICATION_REQUEST = '@notifications/DELETE_NOTIFICATION_REQUEST',
  DELETE_NOTIFICATION_SUCCESS = '@notifications/DELETE_NOTIFICATION_SUCCESS',
  DELETE_NOTIFICATION_FAILURE = '@notifications/DELETE_NOTIFICATION_FAILURE',

  CREATE_NOTIFICATIONS_REQUEST = '@notifications/CREATE_NOTIFICATIONS_REQUEST',
  CREATE_NOTIFICATIONS_SUCCESS = '@notifications/CREATE_NOTIFICATIONS_SUCCESS',
  CREATE_NOTIFICATIONS_FAILURE = '@notifications/CREATE_NOTIFICATIONS_FAILURE',

  UPDATE_NOTIFICATIONS_REQUEST = '@notifications/UPDATE_NOTIFICATIONS_REQUEST',
  UPDATE_NOTIFICATIONS_SUCCESS = '@notifications/UPDATE_NOTIFICATIONS_SUCCESS',
  UPDATE_NOTIFICATIONS_FAILURE = '@notifications/UPDATE_NOTIFICATIONS_FAILURE',

  DELETE_NOTIFICATIONS_REQUEST = '@notifications/DELETE_NOTIFICATIONS_REQUEST',
  DELETE_NOTIFICATIONS_SUCCESS = '@notifications/DELETE_NOTIFICATIONS_SUCCESS',
  DELETE_NOTIFICATIONS_FAILURE = '@notifications/DELETE_NOTIFICATIONS_FAILURE',
}

/*
 * Data types
 */
export interface NotificationInterface {
  id: string;
  name: string;
  title: string;
  body: string;
  imageUrl: string;
  segmentationId: string;
  topic: string;
  data: string;
  type: number;
  status: number;
  createdAt: string;
  updatedAt: string;
}

/*
 * State type
 */
export interface NotificationsState {
  readonly notifications: NotificationInterface[];
  readonly notificationData: NotificationInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
